const Footer = () => {
  return (
    <footer className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-8 text-left mt-auto">
      <p className="text-xs text-muted-foreground">
        {/* © 2009-2025 Sergey Tsibel. All Rights Reserved. */}
      </p>
      <p className="text-xs text-muted-foreground mt-1">
        v.2025.03
      </p>
    </footer>
  )
}

export default Footer 